import { render } from "./LicenseComponent.vue?vue&type=template&id=442dddfa&scoped=true"
import script from "./LicenseComponent.vue?vue&type=script&lang=js"
export * from "./LicenseComponent.vue?vue&type=script&lang=js"

import "./LicenseComponent.vue?vue&type=style&index=0&id=442dddfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442dddfa"]])

export default __exports__